module.exports = __webpack_public_path__ + "assets/img/table.fe7671a5.svg";